import { render, staticRenderFns } from "./DriverShipping.vue?vue&type=template&id=f86599e8&scoped=true"
import script from "./DriverShipping.vue?vue&type=script&lang=js"
export * from "./DriverShipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86599e8",
  null
  
)

export default component.exports